import React from 'react';
import RouteRespPage from './../RouteRespPage/RouteRespPage';
function RouteCategoryRespPage() {

    return <>
        <RouteRespPage isCategoryPage={true}></RouteRespPage>
    </>

}
export default RouteCategoryRespPage;